<template>
  <div class="introduce">
    <Titles :title="data.title" />
    <UkContent :content="data.description" show-bg />
  </div>
</template>
<script>
import Titles from '../UkCourseTitle'
import UkContent from '../UkContent'

export default {
  components: { Titles, UkContent },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}

</script>
<style lang="scss" scoped>
.introduce {
  width: 1240px;
  margin: 0 auto;
  padding-bottom: 40px;

  /deep/.uk-introduce-box { margin-bottom: 0; }
}
</style>
